export default "__VITE_ASSET__DzZZAMI6__"